export const isMockEnabled = () =>
  String(process.env.REACT_APP_MOCK_APIS).toLowerCase() === 'true';
